var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"extensions-slot-component"},_vm._l((_vm.components),function(component){return _c(component.component,_vm._b({key:component.id,tag:"component"},'component',component.attributes,false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }